<template>
  <div class="outerBox">
    <div class="gHead" :style="{ fontSize: fonts.font18 + 'px' }">
      Status of Transaction Request
    </div>
    <div class="spacer"></div>
    <div class="topBox">
      <portal-target name="topBoxText"></portal-target>
      <div class="acctHead" :style="{ fontSize: fonts.font16 + 'px' }">
        {{ xfr.xDesc1 }}</div>
      <div class="acctHead" :style="{ fontSize: fonts.font14 + 'px' }">
        {{ xfr.xDesc3 }}</div>
    </div>
    <div class="spacer"></div>
    <div class="middleBox">
      <portal-target name="middleBoxText"></portal-target>
      <div class="acctHead" :style="{ fontSize: fonts.font16 + 'px' }">
        {{ xfr.fmAcctName }}</div>
      <div class="bCard">
        <div class="groupHeader" :style="{ fontSize: fonts.font10 + 'px' }">
          <span class="grHead" style="width: 40%">Member Account</span>
          <span class="grHead" style="width: 20%">Orig Balance</span>
          <span class="grHead" style="width: 20%">Tran Amount</span>
          <span class="grHead" style="width: 20%">New Balance</span>
        </div>
        <div v-if="xfr.status === 0">
          <div class="groupSection" :style="{ fontSize: fonts.font10 + 'px' }">
            <span class="grPrime" style="width: 40%">{{ xfr.fmDesc }}</span>
            <span class="grRight" style="width: 20%">{{ xfr.fmOrig }}</span>
            <span class="grRight" style="width: 20%">{{ xfr.fmAmnt }}</span>
            <span class="grRight" style="width: 20%">{{ xfr.fmBal }}</span>
          </div>
        </div>
        <div v-if="xfr.status !== 0">
          <div class="groupSection" :style="{ fontSize: fonts.font10 + 'px' }">
            <span class="grPrime" style="width: 40%">{{ xfr.fmDesc }}</span>
            <span class="grPrime" style="width: 60%">{{ xfr.fmError }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="spacer"></div>
    <div class="bottomBox">
      <portal-target name="bottomBoxText"></portal-target>
      <div class="acctHead" :style="{ fontSize: fonts.font16 + 'px' }">
        {{ xfr.toAcctName }}</div>
      <div class="bCard" v-if="xfr.toType !== 'L'">
        <div class="groupHeader" :style="{ fontSize: fonts.font10 + 'px' }">
          <span class="grHead" style="width: 40%">Member Account</span>
          <span class="grHead" style="width: 20%">Orig Balance</span>
          <span class="grHead" style="width: 20%">Tran Amount</span>
          <span class="grHead" style="width: 20%">New Balance</span>
        </div>
        <div v-if="xfr.status === 0">
          <div class="groupSection" :style="{ fontSize: fonts.font10 + 'px' }">
            <span class="grPrime" style="width: 40%">{{ xfr.toDesc }}</span>
            <span class="grRight" style="width: 20%">{{ xfr.toOrig }}</span>
            <span class="grRight" style="width: 20%">{{ xfr.toAmnt }}</span>
            <span class="grRight" style="width: 20%">{{ xfr.toBal }}</span>
          </div>
        </div>
        <div v-if="xfr.status !== 0">
          <div class="groupSection" :style="{ fontSize: fonts.font10 + 'px' }">
            <span class="grPrime" style="width: 40%">{{ xfr.toDesc }}</span>
            <span class="grPrime" style="width: 60%">{{ xfr.toError }}</span>
          </div>
        </div>
      </div>
      <div class="bCard" v-if="xfr.toType === 'L'">
        <div class="groupHeader" :style="{ fontSize: fonts.font10 + 'px' }">
          <span class="grHead" style="width: 20%">Member Account</span>
          <span class="grHead" style="width: 20%">Orig Balance</span>
          <span class="grHead" style="width: 20%">Interest</span>
          <span class="grHead" style="width: 20%">Principal</span>
          <span class="grHead" style="width: 20%">New Balance</span>
        </div>
        <div v-if="xfr.status === 0">
          <div class="groupSection" :style="{ fontSize: fonts.font10 + 'px' }">
            <span class="grPrime" style="width: 20%">{{ xfr.toDesc }}</span>
            <span class="grRight" style="width: 20%">{{ xfr.toOrig }}</span>
            <span class="grRight" style="width: 20%">{{ xfr.toInt }}</span>
            <span class="grRight" style="width: 20%">{{ xfr.toPrin }}</span>
            <span class="grRight" style="width: 20%">{{ xfr.toBal }}</span>
          </div>
        </div>
        <div v-if="xfr.status !== 0">
          <div class="groupSection" :style="{ fontSize: fonts.font10 + 'px' }">
            <span class="grPrime" style="width: 40%">{{ xfr.toDesc }}</span>
            <span class="grPrime" style="width: 60%">{{ xfr.toError }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="spacer"></div>
    <b-button class="btnGreen"
              @click="ok">
      OK
    </b-button>
    <div class="spacer"></div>
    <portal to="topBoxText">
      <div class="tbClass">&nbsp;Posting Status&nbsp;</div>
    </portal>
    <portal to="middleBoxText">
      <div class="mbClass">&nbsp;From Account&nbsp;</div>
    </portal>
    <portal to="bottomBoxText">
      <div class="bbClass">&nbsp;To Account&nbsp;</div>
    </portal>
  </div>
</template>

<script>
// eslint-disable-next-line
import utl from '../myUtils';

export default {
  name: 'postResult',
  data() {
    return {
    };
  },
  computed: {
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    xfr() {
      return this.$store.getters.getXferResult;
    },
    member() {
      return this.$store.getters.getMember;
    },
  },
  methods: {
    ok() { // Go Back
      const cuInfo = {};
      cuInfo.cun = this.cun;
      cuInfo.acct = this.member.acct;
      cuInfo.navVer = this.navVer;
      this.wsSend('c4Refresh', cuInfo);
      window.history.back();
    },
    wsSend(rpc, myObject) {
      const data = Object.assign({}, myObject);
      data.rpcName = rpc;
      this.$store.commit('sendObjToServer', data);
    },
  },
};
</script>

<style scoped>
  .outerBox {
    width: 80%;
    min-width: 300px;
    max-width: 600px;
    display: inline-block;
    border: solid 1px black;
    background: white;
    padding: 0px 0px 0px 0px; /* top, right, bottom, left*/
  }
  .gHead {
    height: 30px;
    background: blue;
    color: white;
  }
  .spacer {
    height: 20px;
  }
  .topBox {
    min-width: 300px;
    max-width: 600px;
    position: relative;
    border: solid 2px red;
    border-radius:10px;
    height: 50px;
  }
  .middleBox {
    min-width: 300px;
    max-width: 600px;
    position: relative;
    border: solid 2px green;
    border-radius:10px;
    height: 72px;
  }
  .bottomBox {
    min-width: 300px;
    max-width: 600px;
    position: relative;
    border: solid 2px blue;
    border-radius:10px;
    height: 72px;
  }
  .tbClass {
    position: absolute;
    background-color: white;
    color: red;
    top: -16px;
    left: 12px;
    height: 20px;
    z-index: 99;
  }
  .mbClass {
    position: absolute;
    background-color: white;
    color: green;
    top: -16px;
    left: 12px;
    height: 20px;
    z-index: 99;
  }
  .bbClass {
    position: absolute;
    background-color: white;
    color: blue;
    top: -16px;
    left: 12px;
    height: 20px;
    z-index: 99;
  }
  .btnGreen {
    border: solid 1px black;
    background-color: lime;
    color: black;
    font-weight: bold;
    padding: 0px;
    height: 25px;
    width: 75px;
  }
  /* ------------------------- */
  .acctHead {
    height: 20px;
  }
  .bCard {
    padding: 4px;
    margin: 0px;
    width: 100%;
  }
  .btnCollapse {
    display: inline-block;
    padding: 0px;
    width: 100%;
    background-color: lightgray;
    color: black;
    font-weight: bold;
    border: solid 2px black;
  }
  .groupHeader {
    position: relative;
    display: inline-flex;
    padding: 0px;
    width: 100%;
    top: -2px;
    height: 18px;
  }
  .groupSection {
    position: relative;
    display: inline-flex;
    padding: 0px;
    width: 100%;
    top: -8px;
    height: 18px;
  }
  .grHead {
    padding: 0px;
    /* height: 26px; */
    background-color: floralwhite;
    color: black;
    font-weight: bold;
    border: solid 1px grey;
  }
  .grPrime {
    /* display: inline-flex; */
    text-align: left;
    padding: 0px;
    padding-left: 4px;
    background-color: transparent;
    font-weight: bold;
    border: solid 1px gray;
  }
  .grLeft {
    text-wrap: avoid;
    text-align: left;
    padding: 0px;
    padding-left: 4px;
    height: 30px;
    background-color: transparent;
    font-weight: bold;
    border: dotted 1px lightgray;
  }
  .grRight {
    text-align: right;
    padding: 0px;
    padding-right: 4px;
    background-color: transparent;
    font-weight: bold;
    border: solid 1px gray;
  }
  .detailBox {
    width: 100%;
    border: solid 4px green;
    padding: 0px;
    padding-bottom: 8px;
  }
  .detailGridBox {
    width: 100%;
    max-width: 500px;
    display: inline-block;
    horiz-align: center;
    border: solid 2px black;
    background-color: white;
  }
  .certDetail {
    width: 100%;
    max-width: 400px;
    display: inline-block;
    horiz-align: center;
    border: solid 2px black;
    background-color: white;
  }
  .detailItem {
    width: 100%;
    /* max-width: 500px; */
    display: inline-flex;
    horiz-align: left;
    border: dotted 1px gray;
  }
  .ddCenter {
    text-align: center;
    width: 100%;
    padding: 0px;
    padding-left: 4px;
    background-color: transparent;
    font-weight: bold;

  }
  .ddLeft {
    text-align: left;
    width: 70%;
    padding: 0px;
    padding-left: 4px;
    background-color: transparent;
    font-weight: bold;

  }
  .ddRight {
    text-align: right;
    width: 30%;
    padding: 0px;
    padding-right: 4px;
    background-color: transparent;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/postResult.vue